import { render, staticRenderFns } from "./MetricChip.vue?vue&type=template&id=518c4d89&scoped=true&"
import script from "./MetricChip.vue?vue&type=script&lang=ts&"
export * from "./MetricChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c4d89",
  null
  
)

export default component.exports